module.exports = {
  "YC_FED_1990880851": "单位/组织全称：",
  "YC_FED_831434141": "请输入您的单位或组织全称",
  "YC_FED_4020825779": "单位/组织所在地：",
  "YC_FED_1028132413": "请输入您的单位或组织所在地",
  "YC_FED_1122636714": "联系人：",
  "YC_FED_67440951": "请输入您的真实姓名",
  "YC_FED_911029432": "联系电话：",
  "YC_FED_2186083564": "填写真实联系电话以便联系您",
  "YC_FED_192667973": "品类:",
  "YC_FED_1333127493": "请选择物资品类",
  "YC_FED_194386418": "物资:",
  "YC_FED_2473871252": "请输入物资名称",
  "YC_FED_194603968": "数量:",
  "YC_FED_3439953582": "请输入数量,  如100个",
  "YC_FED_192826333": "单价:",
  "YC_FED_118396460": "请输入人民币单价",
  "YC_FED_192488796": "要求:",
  "YC_FED_434177049": "请输入物资标准、规格型号、品牌或其他详细要求（0/300）",
  "YC_FED_1213834093": "+ 增加新物资",
  "YC_FED_6437105": "提交",
  "YC_FED_4618299": "关闭",
  "YC_FED_2533636894": "提交成功",
  "YC_FED_606653812": "N95医用防护口罩（GB 19083-2010）及以上",
  "YC_FED_3133487643": "医用外科口罩（YY0469-2011)及以上",
  "YC_FED_4134432385": "防护服（GB 19082-2003）及以上",
  "YC_FED_151877491": "护目镜",
  "YC_FED_208007819": "医用帽",
  "YC_FED_911057188": "一次性手术衣",
  "YC_FED_1682877813": "医用一次性乳胶手套（GB 10213-2006）",
  "YC_FED_2681630027": "防冲击眼罩",
  "YC_FED_2321700280": "防护面罩",
  "YC_FED_159113289": "隔离衣",
  "YC_FED_3028139373": "N95口罩",
  "YC_FED_1144351558": "KN95口罩",
  "YC_FED_3870867899": "其他防护物品",
  "YC_FED_919362501": "提交失败",
  "YC_FED_1068639580": "提交成功,信息需经平台审核通过后方可公布出来",
  "YC_FED_1740703422": "募捐人信息",
  "YC_FED_1037509641": "募捐物资信息",
  "YC_FED_204689708": "供应商",
  "YC_FED_1739264961": "捐赠人信息",
  "YC_FED_1035681206": "捐赠物资信息",
  "YC_FED_200448147": "募捐方",
  "YC_FED_1739269997": "供货人信息",
  "YC_FED_1037192073": "供应物资信息",
  "YC_FED_200551582": "需求方",
  "YC_FED_1740683955": "需求人信息",
  "YC_FED_1037618308": "需求物资信息",
  "YC_FED_2074959271": "所在地:",
  "YC_FED_2068410378": "联系人:",
  "YC_FED_1245154200": "联系电话:",
  "YC_FED_2853835295": "请输入数量,例如:100个",
  "YC_FED_452494987": "请输入单价,例如:100元",
  "YC_FED_1544319898": "申请募捐人信息",
  "YC_FED_4274620010": "定向捐赠人信息",
  "YC_FED_270630829": "申请募捐物资信息",
  "YC_FED_213722159": "捐赠人",
  "YC_FED_1739268934": "受赠人信息",
  "YC_FED_1739323515": "采购人信息",
  "YC_FED_1035728396": "采购物资信息",
  "YC_FED_159160491": "待执行",
  "YC_FED_202378507": "已完成",
  "YC_FED_200536782": "已失效",
  "YC_FED_194436000": "描述:",
  "YC_FED_2406273446": "公开募捐",
  "YC_FED_158279504": "待捐赠",
  "YC_FED_929987013": "我要捐赠",
  "YC_FED_2406173793": "定向募捐",
  "YC_FED_928281369": "公开捐赠",
  "YC_FED_203092231": "待受捐",
  "YC_FED_3782982486": "我要申请受捐",
  "YC_FED_1740703670": "受捐人信息",
  "YC_FED_928292574": "定向捐赠",
  "YC_FED_2564348198": "公开供应",
  "YC_FED_159694250": "待采购",
  "YC_FED_974226303": "我要采购",
  "YC_FED_2564388065": "定向供应",
  "YC_FED_974926435": "公开采购",
  "YC_FED_207857551": "待供应",
  "YC_FED_2563883258": "我要供应",
  "YC_FED_1741057470": "供应人信息",
  "YC_FED_974857828": "定向采购",
  "YC_FED_1593734474": "如果您在疫情防控工作中，存在防护物资的短缺情况，请按照                        以下格式真实反馈，我们将全力助您查寻对应供货渠道(请真实填写)",
  "YC_FED_2395463995": "个人信息",
  "YC_FED_1041404309": "我的真实姓名：",
  "YC_FED_1808074203": "请输入真实姓名",
  "YC_FED_2549854617": "企业名称：",
  "YC_FED_432081186": "请输入企业名称",
  "YC_FED_1710252738": "请输入真实联系电话",
  "YC_FED_1037402129": "短缺物资信息",
  "YC_FED_1220517444": "请填写物资名称及数量，详细的规格型号或其他补充说明（最多可输入400字）",
  "YC_FED_3219929105": "提交成功,物资信息需经平台审核通过后方可公布出来",
  "YC_FED_1462376749": "我已阅读并同意",
  "YC_FED_1182055339": "《用户使用规则及免责声明》",
  "YC_FED_3087410922": "<返回",
  "YC_FED_2348497461": "免责声明",
  "YC_FED_528452416": "第一条 协议订立",
  "YC_FED_4055161575": "1.1用户在同意本网站:智慧云采丨防疫物资紧急采购发布平台 (",
  "YC_FED_3221434543": ")的免责协议后，方可使用本网络服务平台(以下简称“平台”)提供的疫情防护物资供需信息相关服务(以下简称“服务”)。",
  "YC_FED_1736612144": "1.1用户在同意本网站:互助汇丨防疫物资紧急采购发布平台 (",
  "YC_FED_2084807500": "1.2用户在使用本平台提供的服务前请务必认真阅读本协议，一旦用户使用本平台提供的服务即表示用户同意与本平台签订本协议且同意受本协议之约束。",
  "YC_FED_3124526546": "第二条 服务说明",
  "YC_FED_2201916839": "2.1 通过本平台获取的捐赠机构、组织和个体，平台均称为 “捐赠方”，通过本平台获取的物资供应商，平台均称为 “供应方”。本平台仅为技术服务提供方。",
  "YC_FED_3665445276": "2.2 由于情况各异且随时会发生变化，本平台所有供应方、捐赠方目前均无法承诺实际情况。",
  "YC_FED_291743527": "2.3 需求内容以各机构在各大官方发布信息为准(认证微博、官方微信公众号、医院盖章文件等)，平台只做内容收集展示及部分人工核实。",
  "YC_FED_74884276": "第三条 用户的权利和义务",
  "YC_FED_1299145044": "3.1 用户使用本平台前，应仔细阅读各方具体信息。本协议中涉及交易双方、捐赠双方权利义务的内容，如有与我国相关法律冲突的，以我国相关法律为准。",
  "YC_FED_3689983678": "3.2 用户发布信息时，应当准确填写物资类目及具体数量等信息内容。",
  "YC_FED_2434946685": "3.3 如采购方、捐赠方需取得相应凭证，应与相关合作单位联系取得。在交易和捐赠等过程中，如因各项事宜产生争议，由用户与对应方协商解决。",
  "YC_FED_2177695349": "3.4 用户同意本平台向购买方、需求方、捐赠方、接受捐赠方等相关单位披露用户提交的信息中所涉及的各项内容（包括但不限于所在单位、联系电话等个人信息）。",
  "YC_FED_473969063": "第四条 免责说明",
  "YC_FED_2244574431": "4.1 因疫情变化，本平台显示的信息仅供参考，最终以实际供应及需求为准。",
  "YC_FED_478052221": "4.2 因用户提供错误信息所导致的损失，由用户自行承担，本平台不承担任何责任。",
  "YC_FED_251437274": "4.3 用户充分知晓并认可，本平台仅为公益性信息平台，物资供应方与需求方、捐赠方产生任何纠纷与本平台无关，本平台不因平台服务而承担任何担保、保证或连带责任。",
  "YC_FED_1502473923": "4.4 本平台会尽力维护平台信息的安全，但法律规定的不可抗力，以及因为黑客入侵、计算机病毒等原因造成用户资料泄露、丢失、被盗用、被篡改的，本平台不承担任何责任。",
  "YC_FED_3230073079": "4.5 本平台仅提供技术服务，不是交易合同、赠与合同等合同的权利义务主体，不介入用户与交易方之间的纠纷，但本平台将提供协助，保护用户的合法权益。",
  "YC_FED_2152434189": "4.6 本平台如被恶意篡改用于不正当募捐和交易使用，一律追责。",
  "YC_FED_539696760": "4.7 本平台唯一官方网址",
  "YC_FED_3133507652": "(智慧云采丨防疫物资紧急采购需求发布平台)如被人恶意假借名义进行不正当行为，与本平台无关。但本平台保留追究其法律责任的权利。",
  "YC_FED_154048019": "(互助汇丨防疫物资紧急采购需求发布平台)如被人恶意假借名义进行不正当行为，与本平台无关。但本平台保留追究其法律责任的权利。",
  "YC_FED_183727381": "第五条 争议解决及法律适用",
  "YC_FED_2912025593": "5.1 在用户有意向捐赠、求购、发布信息后，如果在约定内容履行过程中，对相关事宜的履行发生争议，用户同意按照中华人民共和国现行有效的相关法律法规来解决争议，并同意接受平台方所在地有管辖权的人民法院的管辖。",
  "YC_FED_2554030307": "募捐专区",
  "YC_FED_2552182054": "采购专区",
  "YC_FED_2553971171": "供应专区",
  "YC_FED_2448709159": "车辆需求",
  "YC_FED_2471655281": "车辆资源",
  "YC_FED_113148420": "全国各大疫区物资紧缺，急需救援！如您愿意可为以下企业单位给予爱心支援！",
  "YC_FED_192519691": "告急!",
  "YC_FED_3475192107": "&nbsp;&nbsp;湖北及其他城市医院防控物资非常紧缺，急需救援！以下是各大医院名单及医院官方发布的资料！请求大家支援！请放心捐赠！",
  "YC_FED_200132291": "待实施",
  "YC_FED_553553962": "联系人： ",
  "YC_FED_2099197199": "地址： ",
  "YC_FED_2619873061": "查看更多",
  "YC_FED_3205136507": "已经到底了",
  "YC_FED_3018779863": "紧急动员全球爱心人士，通过互联网大数据分析帮你联系对应供货渠道，携手共渡难关。",
  "YC_FED_2555520228": "紧急动员全球爱心人士，集结友云采全国5万+优质安全防护类供应商，通过互联网大数据分析尽可能联系对应的供货渠道，携手共渡难关。(人工对接",
  "YC_FED_3602995043": "为快速帮助全国医院及单位及时找到各类防护物资，如您有相关货源，请及时发布出来，感谢支持！",
  "YC_FED_2918819944": "驰援武汉及其他新冠肺炎疫区抗击疫情，用友采购云设立防疫物资供采平台，确保各类医疗防护用品第一时间送达一线医院及工作单位。如果您有相关货源，烦请给予支持！感谢！",
  "YC_FED_568913344": "非定向捐赠",
  "YC_FED_2405343526": "申请受捐",
  "YC_FED_6030255": "提示",
  "YC_FED_2234412832": "授权查看",
  "YC_FED_1927386792": "http://ncc-yc-cpumall-ec.obs.cn-north-4.myhuaweicloud.com/h050u1t9/cfab254d-2129-4fc8-ab3b-c0c7f53d7dba_湖北-恩施.jpg",
  "YC_FED_3577225693": "湖北-恩施",
  "YC_FED_2330653473": "http://ncc-yc-cpumall-ec.obs.cn-north-4.myhuaweicloud.com/h050u1t9/cfa7699b-6ae3-4f8b-bcbe-c56bdbdc9bc8_湖北-监利县.jpg",
  "YC_FED_3036342030": "湖北-监利县",
  "YC_FED_269199880": "http://ncc-yc-cpumall-ec.obs.cn-north-4.myhuaweicloud.com/h050u1t9/53753b9b-0f2b-48e8-b8eb-ce27b18bcb3c_湖北-公安县.jpg",
  "YC_FED_657870771": "湖北-公安县",
  "YC_FED_3130702216": "http://ncc-yc-cpumall-ec.obs.cn-north-4.myhuaweicloud.com/h050u1t9/0e4bc83a-386d-46e5-809f-da12f392124b_湖北-来凤县.jpg",
  "YC_FED_3847805047": "湖北-来凤县",
  "YC_FED_212206716": "提交中",
  "YC_FED_2434616598": "中间商/代理商",
  "YC_FED_6110694": "同意",
  "YC_FED_201634987": "不同意",
  "YC_FED_185226": "是",
  "YC_FED_188803": "否",
  "YC_FED_4796981": "捐赠",
  "YC_FED_2405767290": "我要募捐",
  "YC_FED_978087483": "我要用车",
  "YC_FED_2470384297": "我有资源",
  "YC_FED_4077360456": "物资信息必填",
  "YC_FED_3381849403": "加载中...",
  "YC_FED_2617892266": "互助汇 | 防疫物资紧急采购需求发布平台",
  "YC_FED_1759574121": "智慧云采丨防疫物资紧急采购需求发布平台",
  "YC_FED_3956978529": "用友采购云-疫区物资公益求助平台,快捷发布信息并通过互联网对接供货渠道",
  "YC_FED_212056634": "已分享",
  "YC_FED_2308923102": "互助汇丨防疫物资紧急采购全球供需平台",
  "YC_FED_3071947429": "互助汇-疫区物资公益求助平台,快捷发布信息并通过互联网对接供货渠道",
  "YC_FED_1218218790": "为确保防护物资能第一时间送抵目的地，如您需要物流资源支持，请填写真实需求发布！",
  "YC_FED_163921277": "需求：",
  "YC_FED_1864683465": "车辆需求信息",
  "YC_FED_471295947": "请填写需要的车辆车型，运输区域，计划运输时间区间，计划运输物品或其他补充说明（最多可输入400字）",
  "YC_FED_1323221205": "全国疫区物流资源紧缺，为确保防护物资能第一时间送抵目的地，如您有相关物流资源，烦请发布！",
  "YC_FED_163954859": "资源：",
  "YC_FED_3027635972": "紧急动员全球爱心人士，通过互联网大数据分析帮你联系对应供货渠道，携手共渡难关。（人工对接请联系",
  "YC_FED_1789495300": "紧急动员全球爱心人士，集结友云采全国5万+优质安全防护类供应商，通过互联网大数据分析尽可能联系对应的供货渠道，携手共渡难关。（人工对接",
  "YC_FED_3875593424": "为快速帮助全国医院及单位及时找到各类防护物资，如您有相关货源，请及时发布出来，感谢支持！（人工对接请联系",
  "YC_FED_1857246879": "车辆资源信息"
}


//////////////////
// WEBPACK FOOTER
// ./i18nData/zhcn.js
// module id = wgRm
// module chunks = 1